import React from 'react';
import HeroSection from './HeroSection';
import NewsEventsSection from './NewsEventsSection';
import WarningFooter from './WarningFooter';

const Home = () => {
    return (
        <>
            <HeroSection />
            <NewsEventsSection />
            <WarningFooter />
        </>
    )
}

export default Home;